import React, {useCallback, useEffect, useRef} from 'react';

import {StyledTextArea} from './styled';

interface CustomTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    fullWidth?: boolean;
    rows?: number;
    label?: string;
    placeholder?: string;
    isDisabled?: boolean;
    onTextChange?: (value: string, name?: string) => void;
    name?: string;
    value?: string;
    maxHeight?: number;
    clearInput?: () => void;
}

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
	fullWidth,
	rows = 5,
	label = '',
	placeholder = '',
	isDisabled = false,
	onTextChange,
	name = '',
	value,
	maxHeight,
	clearInput,
}) => {
	const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
	const handleChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (onTextChange) {
			onTextChange(event.target.value, name);
		}
	}, [onTextChange, name]);

	const handleClear = useCallback(() => {
		if (onTextChange) {
			onTextChange('', name);
		}
	}, [onTextChange, name]);

	useEffect(() => {
		if (clearInput) {
			handleClear();
		}
	}, [clearInput, handleClear]);

	return (
		<StyledTextArea
			name={name ? name : ''}
			ref={textAreaRef}
			fullWidth={fullWidth ? true : false}
			rows={rows}
			label={label}
			placeholder={placeholder}
			disabled={isDisabled}
			value={value ? value : ''}
			onChange={handleChange}
			style={{
				overflow: 'auto',
				maxHeight: maxHeight ? `${maxHeight}px` : 'none',
			}}
		/>
	);
};

export default CustomTextArea;